/**
 * Single source of truth for social media profiles.
 *
 * Fill in the `url` field for each network that has a live profile. Empty URLs
 * are skipped automatically:
 *  - The footer renders only icons with non-empty URLs.
 *  - The Organization JSON-LD `sameAs` array (in index.html) should mirror
 *    these — see indexHtmlSameAs() helper.
 *
 * Adding a new network: append to SOCIAL_LINKS and pick an icon from
 * lucide-react.
 */
import { Instagram, Youtube, Twitter, Linkedin, Facebook, type LucideIcon } from "lucide-react";

export interface SocialLink {
  name: string;
  url: string;
  Icon: LucideIcon;
}

export const SOCIAL_LINKS: SocialLink[] = [
  { name: "Instagram", url: "", Icon: Instagram },
  { name: "YouTube",   url: "", Icon: Youtube },
  { name: "X",         url: "", Icon: Twitter },
  { name: "LinkedIn",  url: "", Icon: Linkedin },
  { name: "Facebook",  url: "", Icon: Facebook },
];

export const ACTIVE_SOCIAL_LINKS = SOCIAL_LINKS.filter((s) => s.url.trim().length > 0);
